import clsx from "clsx";
import "./ElementConfiguration.scss";
import {
  Building,
  MapType,
  Resource,
  Unit,
} from "../../../../../../types/project";
import BuildingEditor from "./components/BuildingEditor";
import ResourceEditor from "./components/ResourceEditor";
import UnitEditor from "./components/UnitEditor";
import MapEditor from "./components/MapEditor";

export default function ElementConfiguration({
  activeElement,
}: {
  activeElement: MapType | Unit | Building | Resource | undefined;
}) {
  return (
    <div className={clsx("content")}>
      <>
        {typeof activeElement !== "undefined" &&
        typeof activeElement === "object" ? (
          <>
            {activeElement.type === "building" && <BuildingEditor />}
            {activeElement.type === "resource" && <ResourceEditor />}
            {activeElement.type === "unit" && (
              <UnitEditor activeUnit={activeElement} />
            )}
            {activeElement.type === "map" && <MapEditor />}
          </>
        ) : (
          <></>
        )}
      </>
    </div>
  );
}
